import styled from 'styled-components'

export const Container = styled.div`

`


export const HomeImg = styled.img`
    width: 100%;

`